import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { IMAGE_URL, REACT_APP_API_PORT } from "../Api";
import axios from "axios";
import Loader from "./Loader";

const TopBar = () => {
  const [data, setData] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const getData = async () => {
    try {
      setisLoading(true)
      const res = await axios.get(`${REACT_APP_API_PORT}user/homepage/header-top-section-details`)
      setisLoading(false)
      if (res.data.status) {
        setData(res.data.data)

      }

    }
    catch (err) {
      setisLoading(false)
      console.log(err)
    }
  }

  useEffect(() => {
    getData()
  }, [])
  return (
    <>
    <Loader isLoading={isLoading} />
    <div className="w-full py-2 bg-background-back1">
  <div className="container max-w-[80rem] mx-auto flex flex-col lg:flex-row items-center justify-center lg:justify-end px-4 text-sm text-white text-center lg:text-right">
    <p className="mt-0 flex flex-col md:flex-row items-center gap-2">
      {data?.right_description}
      {data?.button_name && (
        <Link
          className="flex items-center gap-2 text-ice-500"
          to={data?.button_url}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            alt="youtube"
            loading="lazy"
            width="28"
            height="15"
            decoding="async"
            src={IMAGE_URL + data.image || "/images/Youtube_logo.png"}
            className="w-7 h-auto"
          />
          {data?.button_name}
        </Link>
      )}
    </p>
  </div>
</div>

    </>
  );
};

export default TopBar;
